module.exports = __webpack_public_path__ + "728449dfaa5b899724d07285ea235002.png";